module.exports = __webpack_public_path__ + "img/logo.e4b5894b.png";